/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-10 16:51:41
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-07 08:51:37
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentCollapseHeader/index.tsx
 */

import { InfoCircleFilled } from '@ant-design/icons';
import { useClickAway } from 'ahooks';
import { Menu, Tooltip } from 'antd';
// import _ from 'lodash';
import React from 'react';
import LeftGreenBlock from 'src/components/DragContainers/LeftGreenBlock';

import { DropDown, Input } from '@/src/components/Antd';
import { ContentModuleGroupPreloadingContext } from '@/src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading';
import { ICON_PREFIX } from '@/src/tools/constant';
import { Icon } from '@/src/tools/icon';
import { EnumModuleType } from '@/src/types/common/module';
import { useDebounce } from 'ahooks';
import { get } from 'lodash';
import { Field, Form } from 'src/components/RcForm';
import WarningPopReminder from 'src/constrains/PopReminder/Warning';
import {
  checkResponsiveContentCarousel,
  checkResponsiveContentGrid,
  checkResponsiveContentPageTab,
  checkResponsiveImageCarousel,
  checkResponsivePoster,
  checkResponsivePosterTab,
  checkResponsiveProductCarousel,
  checkResponsiveProductGrid,
  checkResponsiveProductTab,
  checkResponsiveSubscription,
  checkResponsiveText,
} from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EContentEnd, EPreviewSize } from 'src/types/common/SalesChannel';
import styles from './css.less';

const ContentModuleItem = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    //data,
    itemNamePrefix,
    listKey,
    form,
    index,
    //additionalPropsToItem,

    onDuplicate,
    //onReset,
    //onNameChange,
    onDelete,
    onClick,

    disabled,
    dragger,
    errorDisplay,
    isSelected,
    CustomVisible,
    hideVisibleDropdownSetting,
    translateDisabled,
  } = props;
  const listData = Form.useWatch([listKey], form);
  const moduleName = [itemNamePrefix, 'moduleName'];

  const ref = React.useRef();

  const [dropVisible, setDropVisible] = React.useState(false);
  const [inputVisible, setInputVisible] = React.useState(false);
  //const [value, setValue] = React.useState(name);

  const data = get(listData, index);
  const word = get(data, 'moduleName');
  const moduleType = get(data, 'moduleType');
  const visible = get(data, 'visible');
  const draggableId = form.getFieldValue([listKey, index, 'draggableId']);

  useClickAway(() => {
    handlePressEnter();
  }, ref);

  const showInput = (e: React.MouseEvent) => {
    e.stopPropagation();
    setInputVisible(true);
  };

  //const handleValueChange = (value) => setValue(value);

  const handleOnCollapseDelete = (e: React.MouseEvent) => {
    if (onDelete) {
      onDelete(draggableId);
    }
  };
  const handleSetVisibility = (e: React.MouseEvent) => {
    e.stopPropagation();
    setDropVisible(false);
  };

  const handlePressEnter = () => {
    setInputVisible(false);
    // if () {
    //   setInputVisible(false);
    // }
  };

  const handleStopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const renderIcon = () => {
    switch (moduleType) {
      case EnumModuleType.Carousel:
        return `${ICON_PREFIX}icon_carousel.svg`;
      case EnumModuleType.ProductCarousel:
        return `${ICON_PREFIX}icon_carousel.svg`;
      case EnumModuleType.Poster:
        return `${ICON_PREFIX}icon_posters.svg`;
      case EnumModuleType.LongCanvas:
        return `${ICON_PREFIX}icon_long-canvas.svg`;
      case EnumModuleType.Text:
        return `${ICON_PREFIX}icon_text.svg`;
      case EnumModuleType.ProductGrid:
        return `${ICON_PREFIX}icon_grid.svg`;
      case EnumModuleType.ProductList:
        return `${ICON_PREFIX}icon_list.svg`;
      case EnumModuleType.Subscription:
        return `${ICON_PREFIX}icon_list.svg`;
      case EnumModuleType.ArticleCarousel:
        return `${ICON_PREFIX}icon_list.svg`;
      case EnumModuleType.ArticleList:
        return `${ICON_PREFIX}icon_list.svg`;
    }
  };

  const isResponsive = [
    EnumModuleType.ResponsiveProductCarousel,
    EnumModuleType.ResponsiveImageCarousel,
    EnumModuleType.ResponsiveContentCarousel,
    EnumModuleType.ResponsiveSubscription,
    EnumModuleType.ResponsiveText,
    EnumModuleType.ResponsivePoster,
    EnumModuleType.ResponsiveProductGrid,
    EnumModuleType.ResponsiveContentGrid,
    EnumModuleType.ResponsiveProductTab,
    EnumModuleType.ResponsiveContentTab,
    EnumModuleType.ResponsivePosterTab,
    EnumModuleType.ResponsiveIframe,
  ].includes(moduleType);

  const renderMenu = () => {
    return (
      <div className='override'>
        <Menu selectedKeys={[]}>
          {!hideVisibleDropdownSetting && (
            <Menu.Item
              key='visibleOnChange'
              onClick={({ item, key, keyPath, domEvent }) => {
                handleSetVisibility(domEvent);
              }}>
              <div>
                {visible
                  ? getI18n('general.setasInvisible')
                  : getI18n('general.setasVisible')}
              </div>
            </Menu.Item>
          )}

          {isResponsive && !disabled ? (
            <React.Fragment>
              <Menu.Item
                key='duplicate'
                onClick={({ item, key, keyPath, domEvent }) => {
                  // handleSetVisibility(domEvent);
                }}>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (onDuplicate) {
                      onDuplicate(draggableId);
                    } //console.log('draggableId2', draggableId);
                    setDropVisible(false);
                  }}>
                  {getI18n('general.duplicate')}
                </div>
              </Menu.Item>

              {/* <Menu.Item key='reset'>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    if (onReset) {
                      onReset(draggableId);
                    }
                    setDropVisible(false);
                  }}>
                  Reset Style
                </div>
              </Menu.Item> */}
            </React.Fragment>
          ) : null}
          {disabled ? null : (
            <Menu.Item key='visibleOnDelete'>
              <WarningPopReminder
                title={getI18n('general.deleteModule')}
                content={getI18n('general.deleteModuleContent')}
                onOk={handleOnCollapseDelete}>
                <div
                  onClick={(e) => {
                    setDropVisible(false);
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                  style={{ color: '#FF695F' }}>
                  {getI18n('general.delete')}
                </div>
              </WarningPopReminder>
            </Menu.Item>
          )}
        </Menu>
      </div>
    );
  };

  return (
    <LeftGreenBlock
      containerStyle={{
        marginBottom: 12,
      }}
      hide={disabled}
      onClick={onClick}
      disabled={translateDisabled}
      {...(dragger || {})}>
      <div
        className={styles.container}
        style={{
          backgroundColor: isSelected ? '#ccefd4' : !visible && '#FAFAFC',
        }}>
        <div className={styles.left}>
          <img src={renderIcon()} alt='' className={styles.image} />
          {CustomVisible || (
            <span className={styles.visible} onClick={handleSetVisibility}>
              <img
                src={
                  visible
                    ? `${ICON_PREFIX}icon_visible.svg`
                    : `${ICON_PREFIX}icon_invisible.svg`
                }
              />
            </span>
          )}

          {inputVisible && !disabled ? (
            <span className={styles.name} ref={ref}>
              <Field name={moduleName}>
                <Input
                  maxLength={50}
                  // value={value}
                  onClick={handleStopPropagation}
                  // onChange={handleValueChange}
                  onPressEnter={handlePressEnter}
                  autoFocus
                />
              </Field>
            </span>
          ) : (
            <Tooltip title={word}>
              <span
                className={styles.name}
                onClick={!!!translateDisabled && showInput}>
                {word}
              </span>
            </Tooltip>
          )}
        </div>
        <div className={styles.right}>
          <Error
            {...(errorDisplay || {})}
            currentDraggableId={draggableId}
            moduleType={moduleType}
          />
          {!disabled && (
            <div className={styles.dropdown}>
              <DropDown
                overlay={renderMenu()}
                trigger={['click']}
                visible={dropVisible}
                onVisibleChange={setDropVisible}
                disabled={translateDisabled}>
                <Icon
                  type='iconMore'
                  className={`${styles.more} ${
                    translateDisabled ? styles.moreDisabled : ''
                  }`}
                  onClick={(e) => e.stopPropagation()}
                />
              </DropDown>
            </div>
          )}
          <Icon type='iconback' className={styles.icon} />
        </div>
      </div>
    </LeftGreenBlock>
  );
};
export default ContentModuleItem;

const Error = (props) => {
  const { options } = React.useContext(ContentModuleGroupPreloadingContext);
  const { inUsePages = [] } = options || {};

  const {
    pcForm,
    mobileForm,
    tabletForm,
    selectedItem,
    moduleData,
    currentDraggableId,
    moduleType,
  } = props;
  const [hasError, setHasError] = React.useState(false);
  const debouncedValue = useDebounce(hasError, { wait: 500 });

  const pcData = Form.useWatch([], pcForm);
  const tabletData = Form.useWatch([], tabletForm);
  const mobileData = Form.useWatch([], mobileForm);
  const handleOnCheckHasError = (
    moduleType,
    pcData,
    tabletData,
    mobileData,
  ) => {
    if (moduleType === EnumModuleType.ResponsiveImageCarousel) {
      const { checkAll } = checkResponsiveImageCarousel();
      const pcError = checkAll(pcData, { breakpoint: EPreviewSize.WIDE });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsiveProductCarousel) {
      const { checkAll } = checkResponsiveProductCarousel();
      const pcError = checkAll(pcData, { breakpoint: EPreviewSize.WIDE });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
      });

      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsiveContentCarousel) {
      const { checkAll } = checkResponsiveContentCarousel();
      const pcError = checkAll(pcData, {
        breakpoint: EPreviewSize.WIDE,
        contentPages: inUsePages,
      });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
        contentPages: inUsePages,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
        contentPages: inUsePages,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsiveProductGrid) {
      const { checkAll } = checkResponsiveProductGrid();
      const pcError = checkAll(pcData, { breakpoint: EPreviewSize.WIDE });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsiveContentGrid) {
      const { checkAll } = checkResponsiveContentGrid();
      const pcError = checkAll(pcData, {
        breakpoint: EPreviewSize.WIDE,
        contentPages: inUsePages,
      });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
        contentPages: inUsePages,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
        contentPages: inUsePages,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsivePosterTab) {
      const { checkAll } = checkResponsivePosterTab();
      const pcError = checkAll(pcData, {
        breakpoint: EPreviewSize.WIDE,
      });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsiveProductTab) {
      const { checkAll } = checkResponsiveProductTab();
      const pcError = checkAll(pcData, {
        breakpoint: EPreviewSize.WIDE,
      });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsiveSubscription) {
      const { checkAll } = checkResponsiveSubscription();
      const pcError = checkAll(pcData, {
        breakpoint: EPreviewSize.WIDE,
      });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsiveText) {
      const { checkAll } = checkResponsiveText();
      const pcError = checkAll(pcData, {
        breakpoint: EPreviewSize.WIDE,
      });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsivePoster) {
      const { checkAll } = checkResponsivePoster();
      const pcError = checkAll(pcData, {
        breakpoint: EPreviewSize.WIDE,
      });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    if (moduleType === EnumModuleType.ResponsiveContentTab) {
      const { checkAll } = checkResponsiveContentPageTab();
      const pcError = checkAll(pcData, {
        breakpoint: EPreviewSize.WIDE,
        contentPages: inUsePages,
      });
      const tabletError = checkAll(tabletData, {
        breakpoint: EPreviewSize.TABLET,
        contentPages: inUsePages,
      });
      const mobileError = checkAll(mobileData, {
        breakpoint: EPreviewSize.MOBILE,
        contentPages: inUsePages,
      });
      const hasError =
        get(pcError, 'hasError') ||
        get(tabletError, 'hasError') ||
        get(mobileError, 'hasError');
      return hasError;
    }
    //checkResponsiveContentPageTab
  };
  const checkErrorList = [
    EnumModuleType.ResponsiveImageCarousel,
    EnumModuleType.ResponsiveProductCarousel,
    EnumModuleType.ResponsiveContentCarousel,
    EnumModuleType.ResponsiveProductGrid,
    EnumModuleType.ResponsiveContentGrid,
    EnumModuleType.ResponsivePosterTab,
    EnumModuleType.ResponsiveProductTab,
    EnumModuleType.ResponsiveSubscription,
    EnumModuleType.ResponsiveText,
    EnumModuleType.ResponsiveContentTab,
    EnumModuleType.ResponsivePoster,
  ];
  const checkFunc = () => {
    if (selectedItem === currentDraggableId) {
      if (checkErrorList.includes(moduleType)) {
        const hasError = handleOnCheckHasError(
          moduleType,
          pcData,
          tabletData,
          mobileData,
        );
        setHasError(hasError);
      }
    } else {
      const cData = get(moduleData, currentDraggableId);
      const pcData = get(cData, EContentEnd.pc);
      const tabletData = get(cData, EContentEnd.tablet);
      const mobileData = get(cData, EContentEnd.mobile);
      const moduleType = get(cData, 'moduleType');
      const hasError = handleOnCheckHasError(
        moduleType,
        pcData,
        tabletData,
        mobileData,
      );

      setHasError(hasError);
    }
  };
  React.useEffect(() => {
    checkFunc();
  }, [selectedItem, pcData, tabletData, mobileData, moduleType]);

  return debouncedValue ? (
    <InfoCircleFilled rev className={styles.iconWarn} />
  ) : null;
};
